import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const BattleCard = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 32 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        fill="none"
        viewBox="0 0 32 32"
        ref={forwardedRef}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M27.2188 28.5312V5.82812L14.5938 8.32812L14.9062 26.8282L27.2188 28.5312Z"
          fill="#E61D27"
          stroke="#2B2F38"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.4063 9.35938L17.8438 14.6713"
          stroke="#2B2F38"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.8894 10.136L23.1463 14.6714"
          stroke="#2B2F38"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.78125 27.3255V3.98438L17.5938 5.6875V24.5732L4.78125 27.3255Z"
          fill="#99E538"
          stroke="#2B2F38"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.34375 16.0469H15.2188"
          stroke="#2B2F38"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.34375 19.5938L15.1562 19.0469"
          stroke="#2B2F38"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.28125 23.1719L15.0938 21.9844"
          stroke="#2B2F38"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.78125 9.71619L10.3438 12.4037L14.5938 8.46619"
          stroke="#2B2F38"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.6562 17.4844H24.1562"
          stroke="#2B2F38"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.6562 20.4219L24.1553 20.5469"
          stroke="#2B2F38"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.5938 23.375L24.1563 23.8281"
          stroke="#2B2F38"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
)

export default BattleCard
